import api from '@/js/services/api';

export default {

    delete(id) {
        return api().delete(`/user/resume/` + id + '/delete');
    },

    getFilesInfo(id, formData) {
        return api().post(`/user/${id}/upload-resume`, formData )
    }
}

